import React, { createContext, useContext, useState } from 'react';

const CurrencyContext = createContext();

const exchangeRate = 1.7; // 1 USD = 1.7 AZN (approximate)

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('AZN'); // AZN or USD

  const convertPrice = (priceInAZN) => {
    if (currency === 'USD') {
      return (priceInAZN / exchangeRate).toFixed(2);
    }
    return priceInAZN.toFixed(2);
  };

  const getCurrencySymbol = () => {
    return currency === 'USD' ? '$' : '₼';
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convertPrice, getCurrencySymbol, exchangeRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};